// extracted by mini-css-extract-plugin
export var alignCenter = "_bc-d";
export var bannerShown = "_bc-6";
export var buttonContent = "_bc-0";
export var cardList = "_bc-1";
export var centerContent = "_bc-2";
export var chevron = "_bc-3";
export var closePanelButton = "_bc-k";
export var conversationContextContainer = "_bc-l";
export var conversationDetailContainer = "_bc-4";
export var detailWrapper = "_bc-7";
export var dropdownButton = "_bc-e";
export var dropdownTitle = "_bc-9";
export var fullHeight = "_bc-5";
export var hidden = "_bc-a";
export var icon = "_bc-b";
export var mergeSuggestionWrapper = "_bc-m";
export var panel = "_bc-i";
export var portalButtonsWrapper = "_bc-c";
export var right = "_bc-j";
export var tableSummaryContainer = "_bc-8";
export var tableSummaryHeader = "_bc-g";
export var threeDotsButton = "_bc-f";
export var wide = "_bc-h";